import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Flame } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a0a0a] text-white">
        <Flame className="w-10 h-10 text-orange-500 animate-pulse" />
        <p className="mt-4 text-white/60 uppercase tracking-widest text-sm">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a0a0a] text-white text-center px-6">
        <div className="font-display text-4xl text-orange-500">Access Denied</div>
        <p className="mt-3 text-white/60 max-w-md">Your account ({user.email}) is not an admin. Ask the site owner to grant access.</p>
      </div>
    );
  }
  return children;
}
